import type {RumKnownApps} from './types'

type PageName = string | undefined

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isGlobalObj = (obj: any) => (obj?.Math === Math ? obj : undefined)

export const GLOBAL_OBJ: Partial<Window & typeof globalThis> =
  (typeof globalThis === 'object' && isGlobalObj(globalThis)) ||
  (typeof window === 'object' && isGlobalObj(window)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof self === 'object' && isGlobalObj(self)) ||
  (typeof global === 'object' && isGlobalObj(global)) ||
  {}

export const getRumGlobal = () => GLOBAL_OBJ.Ya?.Rum

export const getRumPage = () => {
  const {_vars, getErrorSetting} = getRumGlobal() || {}

  return _vars?.['-page'] || getErrorSetting?.('page')
}

export const parseRumPageVar = (page?: unknown) => String(page || getRumPage()).split('.') as [RumKnownApps, PageName]

export const setRumPage = (nextPage: string) => {
  const {setVars, updateErrors} = getRumGlobal() || {}

  setVars?.({'-page': nextPage})
  updateErrors?.({page: nextPage})
}
